export default {
    login: {
        userName: "Benutzername",
        password: "Passwort",
        login: "ANMELDEN",
    },
    navbar: {
        home: "Startseite",
        contracts: "Verträge",
        settings: "Einstellungen",
        info: "Anleitung",
    },
    header: {
        home: "STARTSEITE",
        contracts: "VERTRÄGE",
        settings: "EINSTELLUNGEN",
        info: "ANLEITUNG",
        contract: "VERTRAG",
        addService: "DIENST HINZUFÜGEN",
        service: "DIENST",
    },
    home: {
        hello: "Hallo"
    },
    contracts: {
        active: "Aktiv",
        suspended: "Ausgesetzt",
        services: "Dienste",
        noSuspendedContracts: "Es gibt keine ausgesetzten Verträge",
        noServices: "Es gibt keine ausstehenden Dienstleistungsmitarbeiter in diesem Vertrag",
        noPressupost: "Es gibt keine ausstehenden Zahlungen in diesem Vertrag",
        renovar: "Vertrag erneuern"
    },
    settings: {
        user: "BENUTZER",
        closeSession: "Sitzung schließen",
        settings: "EINSTELLUNGEN",
        appLanguage: "App-Sprache",
        confirmationText: "Bist du sicher, dass du dich abmelden möchtest?"
    },
    info: {

    },
    addService: {
        addTitle: "Dienst beantragen",
        editTitle: "Dienst",
        entrance: "Eintritt ins Camping",
        exit: "Austritt aus dem Camping",
        pickupAtParking: "Wohnwagen am Parkplatz abholen",
        deliveryAtParking: "Wohnwagen zum Parkplatz bringen",
        doneText: "Fertig",
        cancelText: "Abbrechen",
        transportDate: "Transportdatum",
        camping: "Camping",
        selectCamping: "-- Auswählen --",
        parcel: "Grundstück",
        selectParcel: "Wählen Sie das Grundstück aus",
        save: "Speichern",
		payment: "Zahlung",
		paymentTitle: "Zahlung des Dienstes",
		servicePaymentConfirm: "Sind Sie sicher, dass Sie mit der Zahlung dieses Dienstes fortfahren möchten?",
        toastMessage: "Sie müssen alle Felder ausfüllen, um zu speichern!",

        requestService: "Diese Dienstleistung anfordern",
        serviceSummary: "Dienstleistungsübersicht",
        total: "Gesamt",
		paidService: "Dienst bezahlt",
        transactionCompleted: "Transaktion erfolgreich abgeschlossen",
        serviceConfirm: "Sind Sie sicher, dass Sie diese Dienstleistung anfordern möchten?",
        loading: "Service anfordern...",

        reserveNum: "Buchungsnummer",
        selectReserveNum: "Geben Sie die Nummer an",
        availableHoursInfo: "Verfugbarer Transportzeitraum: von {start} bis {end}.",

        toastMessage2: "Um einen Service innerhalb der nächsten 48 Stunden anzufordern, kontaktieren Sie uns bitte."
    },
    service: {
        pending: "Ausstehend",
        completed: "Abgeschlossen",
        requestCompleted: "Der Service wurde korrekt angefordert"
    },
    contract: {
        entrance: "Eintritt",
        exit: "Austritt",
        registration: "Anmeldung",
        initialDate: "Startdatum",
        finalDate: "Enddatum",
        zone: "Zone",
        parkType: "Parktyp",
        pendingServices: "Ausstehende Dienste",
        completedServices: "Abgeschlossene Dienste",
        pendingPressupost: "Ausstehende Zahlungen",
        pendingPressupostS: "Ausstehende Zahlung",
        pay: "Bezahlen",
        acceptConditions: "Die Geschäftsbedingungen akzeptieren",
        acceptConditionsTitle: "Geschäftsbedingungen",
        contractNumberRequired: "Es ist notwendig, die Reservierungsnummer anzugeben, um den Transport zu garantieren"
    },
    interceptors : {
        noAuthorized: "Nicht autorisierter Benutzer"
    },
    payment: {
        confirmed: "Zahlung bestätigt",
        confirmedExtended: "Die Zahlung wurde erfolgreich durchgeführt",
        article: "Artikel",
        price: "Gesamtbetrag",
        informEmail: "Sie erhalten eine E-Mail mit den Zahlungsdetails",
        goBack: "Zurück",
        denied: "Zahlung abgelehnt",
        deniedExtended: "Es gab ein Problem mit der Zahlung",
        deniedInfo: "Versuchen Sie es in ein paar Minuten erneut, und wenn das Problem weiterhin besteht, kontaktieren Sie uns bitte"
    }
};
